// components/dashboard/KPIBoard.jsx

import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Navbar from "../utils/Navbar";
import { useSelector, useDispatch } from "react-redux";

const KPIBoard = () => {
  const { fetchWithAuth, accessToken } = useAuth();
  const [kpiData, setKpiData] = useState(null);
  const [error, setError] = useState(null);
  const filters = useSelector(state => state.filters);

  useEffect(() => {
    const fetchKPI = async () => {
      try {
        const params = new URLSearchParams();

        // Add all filters from Redux
        if (filters.kategorie) params.append("kategorie", filters.kategorie);
        if (filters.ablageort) params.append("ablageort", filters.ablageort);
        if (filters.typ) params.append("typ", filters.typ);
        if (filters.land) params.append("land", filters.land);
        if (filters.material) params.append("material", filters.material);
        if (filters.waehrung) params.append("waehrung", filters.waehrung);
        if (filters.zustand) params.append("zustand", filters.zustand);
        if (filters.eigentuemer) params.append("eigentuemer", filters.eigentuemer);

        if (filters.jahrgangMin) params.append("jahrgang_min", filters.jahrgangMin);
        if (filters.jahrgangMax) params.append("jahrgang_max", filters.jahrgangMax);

        const response = await fetchWithAuth(`/api/main/kpi/?${params}`, {
          headers: { "Content-Type": "application/json" }
        });

        if (!response.ok) {
          throw new Error("Fehler beim Abrufen der KPI-Daten (KPIBoard.jsx).");
        }

        const data = await response.json();
        setKpiData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    if (accessToken) {
      fetchKPI();
    }
  }, [accessToken, filters]);

  if (error) return <div className="text-danger">Fehler: {error}</div>;
  if (!kpiData) return <div>Lade KPI-Daten...</div>;

  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <h3 className="mb-4">📈 KPI Board</h3>

        <div className="card shadow p-4">
          <h5>Gesamtdaten</h5>
          <ul>
            <li><strong>Anzahl Objekte:</strong> {kpiData.anzahl_total}</li>
            <li><strong>Sammlerwert gesamt:</strong> {kpiData.sammlerwert_total?.toFixed(2)} CHF</li>
          </ul>
        </div>

        <div className="accordion" id="kpiAccordion">
          {/* number of objects per country */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Anzahl Objekte je Land
              </button>
            </h2>
            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#kpiAccordion">
              <div className="accordion-body">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr><th>Land</th><th>Anzahl</th></tr>
                  </thead>
                  <tbody>
                    {kpiData.anzahl_je_land.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item["land__name"]}</td>
                        <td>{item.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* collector value per country */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Sammlerwert je Land [CHF]
              </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#kpiAccordion">
              <div className="accordion-body">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr><th>Land</th><th>Sammlerwert</th></tr>
                  </thead>
                  <tbody>
                    {kpiData.sammlerwert_je_land.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item["land__name"]}</td>
                        <td>{item.total?.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* average collector value per country */}
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Durchschnittlicher Sammlerwert je Land [CHF]
              </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#kpiAccordion">
              <div className="accordion-body">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr><th>Land</th><th>Ø Sammlerwert</th></tr>
                  </thead>
                  <tbody>
                    {kpiData.avg_je_land.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item["land__name"]}</td>
                        <td>{item.avg?.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KPIBoard;
